import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';

import { HTTPService, DataService, HelperService, DateService, } from 'app/services';
import { SupplierBulkPaymentComponent } from 'app/modules/app-components';
import { DialogService } from 'primeng/dynamicdialog';

import { config } from 'app/constants';
import { datetimeFormat } from 'app/constants/date-time-format';

@Component({
  selector: 'app-upcoming-supplier-pos',
  templateUrl: './upcoming-supplier-pos.component.html',
  styleUrls: ['./upcoming-supplier-pos.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class UpcomingSupplierPosComponent implements OnInit {
  _user;
  overDuePos: any = [];
  recentPos: any = [];
  overDuePosCount: any = 0;
  recentPosCount: any = 0;
  isPurchaseOrderCreating: boolean = false;
  totalPayable: any;
  isSubletTrackingEnabled : boolean = false;
  @Input('user')
  set user(data: any) {
    if (data) {
      this._user = data;
    }
  }
  @Input() accPayable: boolean = false;

  constructor(private dateService: DateService, private dataService: DataService, private helperService: HelperService, private dialogService: DialogService) { }

  ngOnInit() {
    this.isSubletTrackingEnabled = this.dataService.isSubletTrackingEnabled;
    if (this._user && this._user?.pos && this._user?.pos?.length) {
      this.overDuePos = this.formateDate(this._user?.pos[0]?.overDuePos || []);
      this.recentPos = this.formateDate(this._user?.pos[0]?.recentPos || []);
      this.overDuePosCount = this._user?.pos[0]?.totalPayable[0]?.totalDuePos || 0;
      this.recentPosCount = this._user?.pos[0]?.totalPayable[0]?.totalPos || 0;
    }
  }

  formateDate(data) {
    return data.map((res: any) => {
      return {
        ...res,
        deliveryDate: res.deliveryDate ? this.dateService.formatDate(new Date(res.deliveryDate), datetimeFormat.dddmmmdyy) : '',
        invoiceDate: res.invoiceDate ? this.dateService.formatDate(new Date(res.invoiceDate), datetimeFormat.dddmmmdyy) : '',
      };
    });
  }
  openScheduleAppointmentModal() {
    this.dataService.sendData(
      this.dataService.typeDialog('add-appointment', 'upcoming-appointment', null, null, {
        _id: this._user._id,
        fullName: this._user.fullName,
      })
    );
  }

  viewList() {
    if (this.dataService.isInventoryEnabled) {
      if (this._user.type.value === 'online') {
        this.openListForOnline();
      } else {
        this.openListForInternal();
      }
    } else {
      this.openListForOnline();
    }
  }
  openBulkSupplierModal() {
    this.dialogService.open(SupplierBulkPaymentComponent, {
      width: '1110px',
      styleClass: 'add-dialog add-statement-modal',
      showHeader: false,
      data: { supplier: this._user },
    });
  }

  openPO(poId: string = '') {
    this.isPurchaseOrderCreating = true;
    try {
      this.helperService.openPageInNewTab(`${config.redirectUrl.purchaseOrder}/${poId}?supplierId=${this._user._id}&supplierName=${this._user.name}`);
    } catch (error) {
      this.helperService.showToaster('error', error);
    }
    this.isPurchaseOrderCreating = false;
  }

  openListForOnline() {
    this.helperService.openPageInNewTab(`${config.redirectUrl.poOrderListOnline}`);
  }

  openListForInternal() {
    this.helperService.openPageInNewTab(`${config.redirectUrl.poOrderList}`);
  }
}
